import styled from 'styled-components';
import devices from 'style/breakpoints';
import colors from 'style/palette';



export const PageShop = styled.div`

    width: 100%;
    height: 100%;
`;

export const ShopPageContent = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;

    flex-direction: column;
    gap: 20px;

    width: 100%;

    padding: 20px;

    @media ${devices.tablet} {

        padding: 40px;
    }
`;

export const ShopOperationBox = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;

    flex-direction: column;

    width: 100%;

    margin: 0;

    @media ${devices.tablet} {

        flex-direction: row;
        
        padding: 0 0 0 20px;
    }
`;

export const ShopTitleBox = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;
    align-self: flex-start;

    padding: 0 0 20px;

    gap: 10px;

    @media ${devices.tablet} {

        justify-content: flex-start;

        padding: 0;

        width: 100%;
    }
`;

export const ProductMainInteractionBox = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;

    margin: 25px 0 0;

    flex-direction: column;

    width: 100%;

    @media ${devices.tablet} {

        flex-direction: row;

        gap: 25px;
        
        width: auto;

        margin: 0;
    }
`;

export const ShopTitle = styled.div`

    font-weight: 400;
    font-size: 17px;

    color: rgba(255, 255, 255, 0.7);

    cursor: pointer;

    a {
        
        text-decoration: none;
        color: inherit;
    }
    @media ${devices.tablet} {

        font-size: 28px;
    }
`;

export const SubCategoryProductTitle = styled.div`

    font-weight: 400;
    font-size: 15px;

    color: ${colors.white};

    cursor: pointer;

    @media ${devices.tablet} {

        font-size: 24px;
    }
`;

export const TypeProductTitle = styled.p`

    font-weight: 400;
    font-size: 13px;

    color: ${colors.white};

    @media ${devices.tablet} {

        font-size: 22px;
    }
`;

export const ShopInteractionBox = styled.div`

    margin: 0;
    padding: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0 0 20px;

    width: 100%;

    gap: 20px;

    @media ${devices.tablet} {

        justify-content: flex-end;

        padding: 0;
    }
    `;

export const FilterProductBox = styled.div`

    display: flex;
    align-items: center;
    justify-content: flex-start;

    padding: 10px 0 20px;

    width: 100%;

    gap: 20px;

    @media ${devices.tablet} {
        
        padding: 0;
    }
`;

export const ProductFilterBox = styled.div`

    display: flex;
    align-items: center;
    justify-content: flex-start;

    padding: 0;

    gap: 7px;
`;

export const FilterText = styled.p`

    margin: 0;
    padding: 0;

    font-weight: 400;
    font-size: 14px;
    text-align: center;

    color: ${colors.white};

    @media ${devices.tablet} {

    }
`;

export const SearchBarBox = styled.div`

    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    border: 1px solid ${colors.white};
    border-radius: 100px;
    height: 29px;
    padding: 12px;

    @media ${devices.tablet} {

        max-width: 180px;
        min-width: 180px;
    }
`;

export const SearchBar = styled.input`

    text-align: center;
    font-style: italic;

    width: 100%;
    height: 29px;
    padding: 12px;

    background-color: transparent;

    border: none;

    outline: none;

    color: white;
`;

export const ShopProductBox = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    width: 100%;

    padding: 30px 25px;
    margin: 0;

    background: ${colors.darkGrey};
    box-shadow: 0px 3px 1px -2px ${colors.black020}, 0px 2px 2px ${colors.black014}, 0px 1px 5px ${colors.black012};
    border-radius: 15px;

    gap: 25px;
    
    @media ${devices.tablet} {

        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: stretch;

        padding: 40px;

        column-gap: unset;
        row-gap: 40px;
    }
`;

export const Separator = styled.div`

    display: flex;
    flex-basis: 100%;

    margin: 0 0 30px;

    border: 1px solid ${colors.grey};
`;


export const CleanBox = styled.div`

    display: flex;
`;